import { h } from 'preact';
import nanohref from 'nanohref';
import router from './lib/router';
import { navigateTo, normalizeUrl } from './actions/navigation';

// Actions - maybe these should be moved elsewhere so we don't wind up with a ton of them in this routes file?
import * as siteActions from './actions/site';

// Errors
import Error404 from './components/errors/Error404';


// User Auth
import UserLogin from './components/UserLogin';
import UserRegister from './components/UserRegister';

// Route components
import AuthStripe from './components/auth/AuthStripe';
//import FetchState from './components/ui/FetchState';
import SiteForm from './components/SiteForm';
import SitesList from './components/SitesList';
import SiteView from './components/SiteView';

// Define app routes
export const ADMIN_PREFIX = '/account';

router.get([ADMIN_PREFIX, ADMIN_PREFIX + '/index.html', ADMIN_PREFIX + '/sites'], renderContent(() => <SitesList />));
router.get(ADMIN_PREFIX + '/login', renderContent(() => <UserLogin />));
router.get(ADMIN_PREFIX + '/register', renderContent(() => <UserRegister />));
router.get(ADMIN_PREFIX + '/auth/stripe', renderContent(() => <AuthStripe />));
router.get(ADMIN_PREFIX + '/sites/new', renderContent(() => <SiteForm />));
router.get(ADMIN_PREFIX + '/sites/:siteId', renderContent((params) => {
  //const site = { id: 'test', title: 'Test Site' };
  return siteActions.remote.findById(params.siteId)
    .then(site => <SiteView site={site} />);
}));

function renderContent(renderFunction) {
  return renderFunction;
}

/*
function renderWithLayout(Layout, renderFunction) {
  return function RouterRenderWithLayout(...args) {
    return <Layout>{renderFunction(...args)}</Layout>;
  };
}
*/

/**
 * Get route content
 */
function getContent(path) {
  let content;
  let matched = router.match('/' + normalizeUrl(path));

  if (matched !== false) {
    content = matched.callback(matched.params);
  } else {
    content = <Error404 />;
    console.log('Route 404', path, matched); // eslint-disable-line
    // @TODO: Add <meta name="robots" content="noindex" />
  }

  if (!(content instanceof Promise)) {
    return Promise.resolve(content);
  }

  return content;
}

// Setup nanohref (intercepts all local href clicks and runs this callback)
nanohref(function _handleHrefClick(loc) {
  let urlPath = loc.pathname;

  // Don't hijack links that are not part of the SPA admin area
  if (!urlPath.startsWith(ADMIN_PREFIX)) {
    window.location = urlPath;
    return false;
  }

  navigateTo(urlPath);
});

// When users click the browser 'Back' button
window.addEventListener('popstate', function _handleHistoyPopstate() {
  const urlPath = normalizeUrl(window.location.pathname);

  navigateTo(urlPath, false);
});

module.exports = {
  getContent,
};
